import { all, takeLatest, call } from 'redux-saga/effects'
import getCardDesign from 'services/card-design'
import fetchData from '../helpers/fetchData'
import actions from './actions'

function* fetchCardDesign({ payload }) {
  const service = () => getCardDesign(payload)
  yield call(fetchData, actions.cardDesignApiName, service)
}

export default function* rootSaga() {
  yield all([takeLatest(actions.requestCardDesign, fetchCardDesign)])
}
